import React from 'react';
import { Props } from '../../types';
import { Container } from '../../styles';
import { orange, blue, green, red } from '../../index';

const Status: React.FC<Props> = ({ acronym }) => {
  let text = React.useRef('');
  let color = React.useRef('');

  switch (acronym) {
    case 'ET':
      text.current = 'Em transito';
      color.current = blue;
      break;

    case 'AE':
      text.current = 'Aguardando expedição';
      color.current = red;
      break;

    case 'CC':
      text.current = 'Chegada ao cliente';
      color.current = orange;
      break;

    case 'EF':
      text.current = 'Entrega finalizada';
      color.current = green;
      break;
    default:
      color.current = '#777';
      text.current = 'Sem informações de status';
      break;
  }

  return (
    <Container data-cy="statusAtendimento" color={color.current}>
      {text.current}
    </Container>
  );
};

export default Status;
